import React, { useEffect, useState } from "react";
import BatchesListing from "./BatchesListingForm";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import { useParams } from "react-router-dom";
import { useAssignBatchesStudentByIdQuery , useChangeStudentBatchStatusMutation } from "src/services/StudentServices";
import ATMMenu from "src/components/UI/atoms/ATMMenu/ATMMenu";
import { MdOutlinePublishedWithChanges } from "react-icons/md";
import { showConfirmationDialog } from "src/utils/showConfirmationDialog";
import { showToast } from "src/utils/showToaster";
// import { isCheckColumnPermission } from "src/helpers/userAccessFun";
// import { UserModuleActionTypes, UserModuleNameTypes } from "src/models/userAccess/UserAccess.model";

type Props = {};

const BatchesListingWrapper = (props: Props) => {
  const { studentId = "" } = useParams();
  const [assginBatchData, setAssginBatchData] = useState([]);

 const [batchChangeStatus] =  useChangeStudentBatchStatusMutation()

  const { data, isLoading, isFetching } =
    useAssignBatchesStudentByIdQuery(studentId);

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setAssginBatchData(data?.data?.batches);
    }
  }, [data, isLoading, isFetching]);
  const getActionOptions = (batchId: string) => {
    return [
      {
        label: (
          <div className="flex gap-2 items-center  font-semibold">
            <MdOutlinePublishedWithChanges className="text-lg" /> Change Status
          </div>
        ),
        onClick: () => {
          showConfirmationDialog({
            title: "Heads Up",
            text: "Are you sure want to change the status of this student batch?",
            icon: "question",
            showCancelButton: true,
            next: (result) => {
              if (result?.isConfirmed) {
                batchChangeStatus({
                  id:batchId ,
                  body :{
                    studentId : studentId , 
                  }
                }).then((res: any) => {
                  if (res?.error) {
                    showToast("error", res?.error?.data?.message);
                  } else {
                    if (res?.data?.status) {
                      showToast("success", res?.data?.message);
                    } else {
                      showToast("error", res?.data?.message);
                    }
                  }
                });
              }
            },
          });
        },
      },
    ];
  };

  const columns: columnTypes[] = [
    {
      field: "name",
      headerName: "Batch Name",
      flex: "flex-[1_1_0%]",
      extraClasses: "capitalize",
    },
    {
      field: "fees",
      headerName: "Fees",
      flex: "flex-[1_1_0%]",
      extraClasses: "",
      renderCell: (row: any) => {
        return <span>&#8377; {row?.fees}</span>;
      },
    },
    {
      field: "discountAvail",
      headerName: "Discount",
      flex: "flex-[1_1_0%]",
      extraClasses: "",
      renderCell: (row: any) => {
        return <span>&#8377; {row?.discountAvail}</span>;
      },
    },
    {
      field: "amountPaid",
      headerName: "Paid Amount",
      flex: "flex-[1_1_0%]",
      extraClasses: "",
      renderCell: (row: any) => {
        return (
          <span className="text-green-500">
            &#8377;{" "}
            {Number(row?.fees || 0) -
              Number(row?.discountAvail || 0) -
              Number(row?.dueAmount || 0)}
          </span>
        );
      },
    },
    {
      field: "dueAmount",
      headerName: "Due Amount",
      flex: "flex-[1_1_0%]",
      extraClasses: "",
      renderCell: (row: any) => {
        return <span className="text-red-500">&#8377; {row?.dueAmount}</span>;
      },
    },
    {
      field: "isActive",
      headerName: "isActive",
      flex: "flex-[1_1_0%]",
      renderCell: (row: any) => {
       
        return (
          <div>
            {row?.isActive  ? <span className='text-green-700 font-medium'>Yes</span> : <span className="font-medium text-red-700">No</span> }
          </div>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      flex: "flex-[1_1_0%]",
      extraClasses: " py-2",
      renderCell: (row: any) => {
        const options = getActionOptions(row?.batchId);
        return <ATMMenu options={options} orientation="vertical" />;
      },
    },
  ];

  return (
    <div>
      
      <BatchesListing
          isLoading ={isLoading || isFetching}
        columns={columns}
        rows={assginBatchData}
      />
    </div>
  );
};

export default BatchesListingWrapper;
